module.exports = __webpack_public_path__ + "img/japan-colorectal-cancer-female.c20d0ec6.png";